import React from 'react';

import FinalStepImage from '../assets/images/timeline-final.png';

export const clientBlocks = [
  {
    step: 1,
    heading: 'You request an Estimate',
    body: (
      <>
        <p>You request an Investment and find out if you prequalify in a matter of seconds.</p>
        <p>
          Ready Now?{' '}
          <a href="https://portal.hometap.com/inquiry/data/property/" className="cta-segment-track">
            Get an Estimate.
          </a>
        </p>
      </>
    ),
  },
  {
    step: 2,
    heading: 'You fill out an application',
    body: <p>If it’s a mutual fit and you decide to apply, you’ll complete a short online application.</p>,
  },
  {
    step: 3,
    heading: 'We schedule a signing together',
    body: <p>Once you accept our investment offer, together we’ll schedule the signing.</p>,
  },
  {
    step: 4,
    heading: 'You relax and enjoy!',
    body: (
      <p>
        You use the funds however you choose, while continuing to live in your home - enjoy it, take care of it, keep
        current on your obligations and make good memories.
      </p>
    ),
  },
];

export const hometapBlocks = [
  {
    heading: 'We prepare the numbers',
    body: (
      <p>
        Based on the information you provide, we’ll prepare an Investment Estimate for your property and assign you to a
        dedicated Investment Manager to assist you throughout the process.
      </p>
    ),
  },
  {
    heading: 'We finalize your offer',
    body: (
      <p>
        We’ll order a third-party home appraisal to determine the value of your home. Based off of this data, combined
        with the information in your application, we’ll prepare an investment offer.
      </p>
    ),
  },
  {
    heading: 'We wire funds',
    body: (
      <p>A few days after you close, we’ll wire you the funds in exchange for a Hometap Investment in your home.</p>
    ),
  },
];

export const finalStep = {
  heading: 'You settle the investment',
  body: (
    <p>You sell or settle the investment before the end of your 10 year term. Hometap is paid our agreed upon share</p>
  ),
  finalStepImage: FinalStepImage,
};
